/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.ts to modify the generation of this file.


import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-nextjs';

import { SeoFooterLinkList, SeoFooter, IconLinkList, SiteFooter, Header, NavMenu, AlertBanner, InformationNotification, IntroductionCta } from '@greystar/ui';
import { BYOCWrapper, FEaaSWrapper } from '@sitecore-jss/sitecore-jss-nextjs';
import { Form } from '@sitecore-jss/sitecore-jss-nextjs';

import * as CdpPageView from 'src/components/CdpPageView';
import * as ColumnSplitter from 'src/components/ColumnSplitter';
import * as Container from 'src/components/Container';
import * as ContentBlock from 'src/components/ContentBlock';
import * as FEAASScripts from 'src/components/FEAASScripts';
import * as Image from 'src/components/Image';
import * as LinkList from 'src/components/LinkList';
import * as Navigation from 'src/components/Navigation';
import * as PageContent from 'src/components/PageContent';
import * as PartialDesignDynamicPlaceholder from 'src/components/PartialDesignDynamicPlaceholder';
import * as Promo from 'src/components/Promo';
import * as RowSplitter from 'src/components/RowSplitter';
import * as Title from 'src/components/Title';
import * as DataDogInit from 'src/components/DataDog/DataDogInit';
import * as CommunityContactForm from 'src/components/PDP/CommunityContactForm';
import * as PropertyDetails from 'src/components/PDP/PropertyDetails';
import * as PropertyDetailsAmenities from 'src/components/PDP/PropertyDetailsAmenities';
import * as PropertyDetailsBreadcrumb from 'src/components/PDP/PropertyDetailsBreadcrumb';
import * as PropertyDetailsCalculatorStructure from 'src/components/PDP/PropertyDetailsCalculatorStructure';
import * as PropertyDetailsContactDisclaimers from 'src/components/PDP/PropertyDetailsContactDisclaimers';
import * as PropertyDetailsCtasRow from 'src/components/PDP/PropertyDetailsCtasRow';
import * as PropertyDetailsFeeCalculator from 'src/components/PDP/PropertyDetailsFeeCalculator';
import * as PropertyDetailsFees from 'src/components/PDP/PropertyDetailsFees';
import * as PropertyDetailsFloorPlans from 'src/components/PDP/PropertyDetailsFloorPlans';
import * as PropertyDetailsFloorPlansSections from 'src/components/PDP/PropertyDetailsFloorPlansSections';
import * as PropertyDetailsGreatSchools from 'src/components/PDP/PropertyDetailsGreatSchools';
import * as PropertyDetailsImageGallery from 'src/components/PDP/PropertyDetailsImageGallery';
import * as PropertyDetailsMap from 'src/components/PDP/PropertyDetailsMap';
import * as PropertyDetailsNeighborhood from 'src/components/PDP/PropertyDetailsNeighborhood';
import * as PropertyDetailsOverview from 'src/components/PDP/PropertyDetailsOverview';
import * as PropertyDetailsStructure from 'src/components/PDP/PropertyDetailsStructure';
import * as ToursSection from 'src/components/PDP/ToursSection';

export const components = new Map();
components.set('SeoFooterLinkList', SeoFooterLinkList);
components.set('SeoFooter', SeoFooter);
components.set('IconLinkList', IconLinkList);
components.set('SiteFooter', SiteFooter);
components.set('Header', Header);
components.set('nav-menu', NavMenu);
components.set('alert-banner', AlertBanner);
components.set('information-notification', InformationNotification);
components.set('introduction-cta', IntroductionCta);
components.set('BYOCWrapper', BYOCWrapper);
components.set('FEaaSWrapper', FEaaSWrapper);
components.set('Form', Form);

components.set('CdpPageView', CdpPageView);
components.set('ColumnSplitter', ColumnSplitter);
components.set('Container', Container);
components.set('ContentBlock', ContentBlock);
components.set('FEAASScripts', FEAASScripts);
components.set('Image', Image);
components.set('LinkList', LinkList);
components.set('Navigation', Navigation);
components.set('PageContent', PageContent);
components.set('PartialDesignDynamicPlaceholder', PartialDesignDynamicPlaceholder);
components.set('Promo', Promo);
components.set('RowSplitter', RowSplitter);
components.set('Title', Title);
components.set('DataDogInit', DataDogInit);
components.set('CommunityContactForm', CommunityContactForm);
components.set('PropertyDetails', PropertyDetails);
components.set('PropertyDetailsAmenities', PropertyDetailsAmenities);
components.set('PropertyDetailsBreadcrumb', PropertyDetailsBreadcrumb);
components.set('PropertyDetailsCalculatorStructure', PropertyDetailsCalculatorStructure);
components.set('PropertyDetailsContactDisclaimers', PropertyDetailsContactDisclaimers);
components.set('PropertyDetailsCtasRow', PropertyDetailsCtasRow);
components.set('PropertyDetailsFeeCalculator', PropertyDetailsFeeCalculator);
components.set('PropertyDetailsFees', PropertyDetailsFees);
components.set('PropertyDetailsFloorPlans', PropertyDetailsFloorPlans);
components.set('PropertyDetailsFloorPlansSections', PropertyDetailsFloorPlansSections);
components.set('PropertyDetailsGreatSchools', PropertyDetailsGreatSchools);
components.set('PropertyDetailsImageGallery', PropertyDetailsImageGallery);
components.set('PropertyDetailsMap', PropertyDetailsMap);
components.set('PropertyDetailsNeighborhood', PropertyDetailsNeighborhood);
components.set('PropertyDetailsOverview', PropertyDetailsOverview);
components.set('PropertyDetailsStructure', PropertyDetailsStructure);
components.set('ToursSection', ToursSection);

export const componentBuilder = new ComponentBuilder({ components });

export const moduleFactory = componentBuilder.getModuleFactory();
